// Brand Loading & Busy-State Standard skeleton color: parchment light /
// faint translucent white dark — never the MUI default gray. Light rides
// theme.palette.divider, which ThemeContext sets to brand.parchmentDark
// (#E8E0D0). Shared by all payment-frontend skeleton components.
export const skeletonBg = (theme) => ({
  bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : theme.palette.divider,
});
